import { render, staticRenderFns } from "./XDefaultDataTable.vue?vue&type=template&id=47fa4067&"
import script from "./XDefaultDataTable.vue?vue&type=script&lang=ts&"
export * from "./XDefaultDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../public-charging/admin-portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports